export class Utility {
    
    
    /**
     * Like object.assign, except ignores undefined values, leaving them on the target object
     * @param target The object to copy to
     * @param sources The objects to copy from
     * @returns 
     */
    static  assignDefined(target: any, ...sources: any) {
        for (const source of sources) {
            for (const key of Object.keys(source)) {
                const val = source[key];
                if (val !== undefined) {
                    target[key] = val;
                }
            }
        }
        return target;
    }

    static isUrl(url: string) {
        try {
            new URL(url)
            return true
        }
        catch (e) {
            return false
        }
    }

    static getContentDispositionFilename(header: string) {
        let filenameIndex = header.indexOf("filename=")
        if (!filenameIndex) {
          throw new Error("Missing filename in first letter download")
        }

        return header.substring(filenameIndex + 9).replace(`"`, "")

    }

    static  flattenObject(obj: any) {
        const result: any = {};
      
        function flatten(obj: any, prefix = '') {
          for (const key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null && !(obj[key] instanceof Array)) {
              flatten(obj[key], prefix + key + '_');
            } else {
              result[prefix + key] = obj[key];
            }
          }
        }
      
        flatten(obj);
        return result;
      }
}